// extracted by mini-css-extract-plugin
export default {"container":"OrderComplain_container__5wXTt","content":"OrderComplain_content__LKSLv"};